import { EVENTS } from '../core/constants';
import { paramGetters } from '../params';
import type { EventName, EventContext } from '../types'

type ParamName = keyof typeof paramGetters;

/**
 * Resolve and return the required parameters for a given event.
 *
 * @param context - Context passed to each parameter getter (defaults to an empty object)
 * @param eventName - The event whose required parameters should be resolved
 * @returns An object mapping each required parameter name to its resolved value (`null` when a param getter is missing), or `undefined` if the event has no configuration
 */
export async function getParameters(context: EventContext = {}, eventName: EventName) {
  const eventConfig = EVENTS[eventName] as { requiredParams: string[] };

  if (!eventConfig) return;

  const params = Object.fromEntries(
    await Promise.all(
      eventConfig.requiredParams.map(async (param) => {
        const getter = paramGetters[param as ParamName];

        if (typeof getter !== 'function') {
          console.error(`[DT] Missing paramGetter for param: ${param}`);
          return [param, null]; // ou undefined
        }
        
        return [param, await getter(context, eventName)];
      })
    )
  );

  return params;
}
